module.exports = __webpack_public_path__ + "static/media/W_Befaring.c39c1479.jpg";